module.exports = __webpack_public_path__ + "images/bannerDE-e5d533c94c085e45d493ecd3302a9843.jpg";